module.exports = __webpack_public_path__ + "img/MiniFenomeno.40a80c14.png";